export const formationGroupsEn = {
  title: "Training groups",
  subtitle:
    "A training group brings together the participants of one training session and chooses the goals presented to them.",
  create: "Create a training group",
  edit: "Edit",
  reset: "Reset",
  delete: "Delete",
  cancel: "Cancel",
  save: "Save",
  back: "Back",
  error: "Something went wrong. Please try again.",
  list: {
    name: "Name",
    participants: "Participants",
    createdAt: "Creation date",
    actions: "Actions",
    view: "View",
    empty: "No training groups yet.",
  },
  form: {
    nameLabel: "Group name",
    namePlaceholder: "Waste management workshop",
    nameRequired: "Please enter a name for the training group.",
    goalsLabel: "Goals presented to the participants",
    goalsHelp: "This group's participants will see these goals, and only these.",
    goalsRequired: "The group must keep at least one goal.",
    ofTotal: "/ {{total}} goals presented to the participants",
    emptyThematics: "No goal kept in {{thematics}}",
    searchGoal: "Search for a goal",
    searchGoalPlaceholder: "Search for a goal…",
    allIssues: "All issues",
    searchIssue: "Search for an issue…",
    noIssueMatches: "No issue matches.",
    filterByState: "Filter by state",
    thematic: "Theme",
    status: {
      all: "All",
      on: "Selected",
      off: "Not selected",
    },
    shown_one: "{{count}} goal shown",
    shown_other: "{{count}} goals shown",
    selectAll: "Select all",
    clearAll: "Remove all",
    selectShown_one: "Select the {{count}} shown",
    selectShown_other: "Select the {{count}} shown",
    clearShown_one: "Remove the {{count}} shown",
    clearShown_other: "Remove the {{count}} shown",
    scope: "{{selected}} / {{shown}} selected in this filter",
    reset: "Restore the starting selection ({{count}})",
    resetHint: "Restores the starting selection, whichever filters are active",
    resetNoop: "The selection is already the starting one",
    noGoalMatches: "No goal matches this filter.",
    createTitle: "Create a training group",
    editTitle: "Edit the training group",
    createSubmit: "Create the group",
  },
  participantProfileTitle: "Participant's company profile",
  enrolment: {
    title: "Enrolment",
    code: "Enrolment code",
    open: "Enrolment open",
    closed: "Enrolment closed",
    openShort: "Open",
    closedShort: "Closed",
    openAction: "Open enrolment",
    close: "Close enrolment",
    regenerate: "Regenerate the code",
    usableHint: "Participants can enter this code to join the group.",
    closedHint: "The code does not work while enrolment is closed.",
    link: "Enrolment link",
    copyLink: "Copy link",
    linkCopied: "Link copied.",
    linkCopyFailed: "Could not copy the link.",
  },
  regenerateDialog: {
    title: "Regenerate the enrolment code",
    body:
      "The code \"{{code}}\" will stop working immediately and will be replaced by a new one.",
    participants:
      "Participants already enrolled keep their access and their work.",
  },
  toasts: {
    created: "The training group \"{{name}}\" has been created.",
    opened:
      "Enrolment in training group \"{{name}}\" is open. Its code is {{code}}.",
    closed:
      "Enrolment in training group \"{{name}}\" is closed. Participants already enrolled keep their access and their work.",
    regenerated:
      "The code for training group \"{{name}}\" is now {{code}}. The previous code no longer works.",
    updated: "The training group \"{{name}}\" has been updated.",
    deleted: "The training group \"{{name}}\" has been deleted.",
    participantRemoved: "{{participant}} has been removed from the training group.",
    reset_zero:
      'Group "{{name}}" had no participants. Its new code is {{code}}; the old one no longer works.',
    reset_one:
      '{{count}} participant has been removed from group "{{name}}". Its new code is {{code}}; the old one no longer works.',
    reset_other:
      '{{count}} participants have been removed from group "{{name}}". Its new code is {{code}}; the old one no longer works.',
    profileUpdated: "{{participant}}'s company profile has been updated.",
  },
  detail: {
    participants: "Participants",
    participantCount_one: "{{count}} participant",
    participantCount_other: "{{count}} participants",
    goalCount_one: "{{count}} goal selected",
    goalCount_other: "{{count}} goals selected",
    noGoals: "No goal selected.",
    close: "Close",
    editGoals: "Edit the selection",
    goals: "Goals presented to the participants",
    participant: "Participant",
    data: "Participant's data",
    assessment: "Self-assessment",
    actionPlan: "Action plan",
    profileOf: "Profile of {{name}} ({{email}}).",
    profile: "Company profile",
    viewing: "{{name}}'s data",
    history: "History",
    remove: "Remove",
    removeConfirm:
      "Remove this participant from the group? Their account and answers are kept.",
    noParticipants: "No participants in this group yet.",
    noProfile: "No data until the company profile is created.",
    createdOn: "created on",
  },
  resetDialog: {
    title: "Reset the training group",
    // Zero gets its own sentence rather than a count — see the French file for
    // why the plural rule cannot carry it. It no longer says the reset changes
    // nothing: the code is retired even here.
    body_zero: 'Group "{{name}}" has no participants.',
    body_one: '{{count}} participant will be removed from group "{{name}}".',
    body_other: '{{count}} participants will be removed from group "{{name}}".',
    preserved:
      "Accounts, answers, action plans and showcases are kept. The group keeps its name and its goal set, and stays ready for the next cohort.",
    confirm: "Reset",
  },
  deleteDialog: {
    title: "Delete the training group",
    body: 'The group "{{name}}" and its memberships will be deleted.',
    accounts_one: "The participant's account and answers are not affected.",
    accounts_other:
      "The accounts of the {{count}} participants and their answers are not affected.",
  },
  steps: {
    none: "Company profile not created",
  },
} as const;
